import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useLogin } from '../lib/queries.js';
import { ApiError } from '../lib/api.js';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const login = useLogin();
  const nav = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      const me = await login.mutateAsync({ email, password });
      if (!('admin' in me) || !me.admin) {
        setError('Conta sem permissão de admin.');
        return;
      }
      nav({ to: '/' });
    } catch (err) {
      if (err instanceof ApiError) {
        if (err.status === 429) setError('Muitas tentativas. Aguarde alguns minutos.');
        else if (err.status === 401) setError('Credenciais inválidas.');
        else setError(err.message);
      } else {
        setError('Erro inesperado');
      }
    }
  }

  return (
    <main className="min-h-dvh grid place-items-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-3">
        <div className="flex items-center gap-2 mb-4">
          <div className="size-2 rounded-full bg-rose-500" />
          <h1 className="text-xl font-semibold">Flowmindy Admin</h1>
        </div>
        <input
          type="email"
          required
          placeholder="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-md bg-zinc-900 border border-zinc-800 px-3 py-2"
        />
        <input
          type="password"
          required
          placeholder="senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-md bg-zinc-900 border border-zinc-800 px-3 py-2"
        />
        {error && <div className="text-rose-400 text-sm">{error}</div>}
        <button
          type="submit"
          disabled={login.isPending}
          className="w-full rounded-md bg-rose-500 text-zinc-950 font-medium py-2 hover:bg-rose-400 disabled:opacity-50"
        >
          {login.isPending ? 'entrando…' : 'Entrar'}
        </button>
        <p className="text-xs text-zinc-500 mt-3">
          Acesso restrito a admins. Tentativas de não-admin geram audit log.
        </p>
      </form>
    </main>
  );
}
